
import { DatePicker, Flex, Form, Input, Modal } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createFieldAgent,
  createSupervisor,
  createTeamLead,
  createTeleCaller,
} from "../../../api/AddUser";
import { ReactComponent as Calender } from "../../../assets/Icons/calendarIcon.svg";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";
import DragUpload from "../../../Reuseable/DragUpload/DragUpload";
import InputField from "../../../Reuseable/InputField/InputField";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import CustomSelect from "../../../Reuseable/Select/Select";
import Tabs from "../../../Reuseable/Tabs/Tabs";
import dayjs from "dayjs";
import { fetchAgencyProfile } from "../../../store/agencySlice";
import {
  fetchFieldAgents,
  fetchTeamLeads,
  fetchTeleCallers
} from "../../../store/userRoleSlice";
import "./AddUserModal.scss";

const AddUserModal = ({ open, onClose, onSubmit, bankData, areaCodes }) => {
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState("TeleCaller");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [pccFile, setPccFile] = useState(null);
  const [telacallerPccFile, setTelecallerPccFile] = useState(null);
  const [qualificationFile, setQualificationFile] = useState(null);
  const [draFile, setDraFile] = useState(null);

  const {
    // supervisors,
    // supervisors_loading,
    team_leads,
    team_leads_loading,
    field_agents,
    field_agents_loading,
    telecallers,
    telecallers_loading,
  } = useSelector((state) => state?.userRoles);

  const { agency_profile, profile_loading } = useSelector(
    (state) => state?.agency
  );

  const { token, user } = useSelector((state) => state.auth);


  useEffect(() => {
    if (open && user?.is_agency) {
      dispatch(fetchFieldAgents());
      dispatch(fetchTeamLeads());
      dispatch(fetchTeleCallers());
      dispatch(fetchAgencyProfile());
    }
  }, [dispatch, open, user]);


  const teamLeadOptions =
    team_leads?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const telecallerOptions =
    telecallers?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const fieldAgentOptions =
    field_agents?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const areaOptions =
    areaCodes?.map((item) => ({
      label: item.areacode,
      value: item.id,
    })) || [];


  const handleFinish = async (values) => {
   
    setLoading(true);
    const commonPayload = {
      email: values.loginEmail,
      name: values.name,
      date_of_joining: dayjs(values.joiningDate).format("YYYY-MM-DD"),
      mobile_no: values.mobile,
      address: values.address,
      registered_email: values?.registeredEmail,
    };

    let rolePayload = {};

    switch (activeTab) {
      case "Supervisor":
        rolePayload = {
          area: values.area,
          team_lead: values.teamLead,
          tele_callers: values.tele_callers,
          field_agents: values.field_agents,
        };
        break;

      case "TeamLead":
        rolePayload = {
          area: values.area,
          tele_callers: values.tele_callers,
          field_agents: values.field_agents,
          banks: values.banks,
        };
        break;

      case "TeleCaller":
        rolePayload = {
          area: values.area,
          field_agents: values.assignedAgents,
          mother_tongue: values["Mother Tongue"],
          campaign_id: values.campaign_id,
          agent_id: values.agent_id,
          first_name:values?.first_name,
          last_name:values?.last_name,
          pcc:telacallerPccFile
        };
        break;

      case "Field Agent":
        rolePayload = {
          area: values.area,
          mother_tongue: values["Mother Tongue"],
          pcc: pccFile,
          qualification: qualificationFile,
          dra: draFile,
        };
        break;

      default:
        break;
    }

    const finalPayload = {
      ...commonPayload,
      ...cleanEmptyFields(rolePayload),
    };

    try {
      let result;
      switch (activeTab) {
        case "Supervisor":
          result = await createSupervisor(
            finalPayload,
            token,
            agency_profile?.id
          );
          break;
        case "TeamLead":
          result = await createTeamLead(
            finalPayload,
            token,
            agency_profile?.id
          );
          break;
        case "TeleCaller":
          result = await createTeleCaller(
            finalPayload,
            token,
            agency_profile?.id,
          );
          break;
        case "Field Agent":
          result = await createFieldAgent(finalPayload, token);
          break;
      }

      CustomNotification.show(`${activeTab} created successfully`, "success");
      setLoading(false);

      onSubmit?.(finalPayload);

      onClose();
      form.resetFields();
    } catch (error) {

      CustomNotification.show(
        error?.message || "Something went wrong",
        "error"
      );
      setLoading(false);
    }
  };
  const cleanEmptyFields = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([_, v]) =>
          v !== undefined &&
          v !== null &&
          (Array.isArray(v) ? v.length > 0 : true)
      )
    );
  };

  const tabOptions = [
    { label: "TeleCaller", value: "TeleCaller" },
    { label: "Supervisor", value: "Supervisor" },
    { label: "TeamLead", value: "TeamLead" },
    { label: "Field Agent", value: "Field Agent" },
  ];

  const roleSpecificFields = {
    Supervisor: (
      <Flex className="form-group">
        <Flex className="form-field">
          <Form.Item
            name="teamLead"
            rules={[{ required: false, message: "Please select team lead" }]}
          >
            <CustomSelect
              label="TeamLead"
              placeholder="Select TeamLead"
              options={teamLeadOptions}
              isMultiSelect={true}
            />
          </Form.Item>

          <Form.Item
            name="area"
            rules={[
              { required: false, message: "Please select operational areas" },
            ]}
          >
            <CustomSelect
              label="Operational Areas"
              placeholder="Select Areas"
              options={areaOptions}
              isMultiSelect={true}
            />
          </Form.Item>
        </Flex>
        <Flex className="form-field">
          <Form.Item
            name="tele_callers"
            rules={[{ required: false, message: "Please select telecallers" }]}
          >
            <CustomSelect
              label="TeleCallers"
              placeholder="Select"
              options={telecallerOptions}
              isMultiSelect={true}
            />
          </Form.Item>
          <Form.Item
            name="field_agents"
            rules={[{ required: false, message: "Please select field agents" }]}
          >
            <CustomSelect
              label="Field Agents"
              placeholder="Select"
              options={fieldAgentOptions}
              isMultiSelect={true}
            />
          </Form.Item>
        </Flex>
      </Flex>
    ),
    TeamLead: (
      <div className="form-group">
        <Flex className="form-field">
          <Form.Item name="area">
            <CustomSelect
              label="Operational Areas"
              placeholder="Select Areas"
              options={areaOptions}
              isMultiSelect={true}
            />
          </Form.Item>
          <Form.Item name="tele_callers">
            <CustomSelect
              label="TeleCallers"
              placeholder="Select"
              options={telecallerOptions}
              isMultiSelect={true}
            />
          </Form.Item>
        </Flex>
        <Flex className="form-field">
          <Form.Item name="field_agents">
            <CustomSelect
              label="Field Agents"
              placeholder="Select"
              options={fieldAgentOptions}
              isMultiSelect={true}
            />
          </Form.Item>

          <Form.Item name="banks">
            <CustomSelect
              label="Bank"
              placeholder="Select Bank"
              options={bankData?.map((bank) => ({
                label: bank?.name,
                value: String(bank?.id),
              }))}
              isMultiSelect={true}
            />
          </Form.Item>
        </Flex>
      </div>
    ),
    TeleCaller: (
      <div className="form-group telecallerFormGroup">
        <Flex className="form-field">
          <Form.Item name="area">
            <CustomSelect
              label="Operational Areas"
              placeholder="Select Areas"
              options={areaOptions}
              isMultiSelect={true}
            />
          </Form.Item>
          <Form.Item name="assignedAgents">
            <CustomSelect
              label="Field Agents"
              placeholder="Select"
              options={fieldAgentOptions}
              isMultiSelect={true}
            />
          </Form.Item>
          <Form.Item name="Mother Tongue">
            <CustomSelect
              label="Mother Tongue"
              placeholder="Select Language"
              options={[
                { value: "hindi", label: "Hindi" },
                { value: "bengali", label: "Bengali" },
                { value: "english", label: "English" },
                { value: "punjabi", label: "Punjabi" },
                { value: "marathi", label: "Marathi" },
              ]}
            />
          </Form.Item>
          <Form.Item name="campaign_id" rules={[{ required: true }]}>
              <InputField label="campaign id" placeholder={`Type ${activeTab} Campaign id`} />
            </Form.Item>
            <Form.Item name="agent_id" rules={[{ required: true }]}>
              <InputField label="Agent id" placeholder={`Type ${activeTab} Agent id`} />
            </Form.Item>
            <Flex className="form-field uploadGrp">
              <Form.Item
            name="pccDocument"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
          >
            {telacallerPccFile !== null ? (
              <DragUpload
                label="PCC Document"
                name="pcc"
                setFile={setTelecallerPccFile}
                readOnly={true}
                file={telacallerPccFile}
              />
            ) : (
              <DragUpload
                label="PCC Document"
                name="pcc"
                multiple={false}
                onChange={(fileList) =>
                  setTelecallerPccFile(fileList && fileList[0]?.originFileObj)
                }
              />
            )}
          </Form.Item>
            </Flex>
        </Flex>
      </div>
    ),
    "Field Agent": (
      <div className="form-group">
        <Flex className="form-field">
          <Form.Item name="area">
            <CustomSelect
              label="Operational Areas"
              placeholder="Select Areas"
              options={areaOptions}
              isMultiSelect={true}
            />
          </Form.Item>
        </Flex>
        <Flex className="form-field">
          <Form.Item name="Mother Tongue">
            <CustomSelect
              label="Mother Tongue"
              placeholder="Select Language"
              options={[
                { value: "hindi", label: "Hindi" },
                { value: "bengali", label: "Bengali" },
                { value: "english", label: "English" },
                { value: "punjabi", label: "Punjabi" },
                { value: "marathi", label: "Marathi" },
              ]}
            />
          </Form.Item>
        </Flex>
        <h2 className="upload-heading">Update Documents</h2>
        <Flex className="form-field uploadGrp">
          <Form.Item
            name="pccDocuments"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
          >
            {pccFile !== null ? (
              <DragUpload
                label="PCC Documents"
                name="pcc"
                setFile={setPccFile}
                readOnly={true}
                file={pccFile}
              />
            ) : (
              <DragUpload
                label="PCC Documents"
                name="pcc"
                multiple={false}
                onChange={(fileList) =>
                  setPccFile(fileList && fileList[0]?.originFileObj)
                }
              />
            )}
          </Form.Item>
          <Form.Item
            name="Qualification-Documents"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
          >
            {qualificationFile !== null ? (
              <DragUpload
                label="Qualification Documents"
                name="qualification"
                setFile={setQualificationFile}
                readOnly={true}
                file={qualificationFile}
              />
            ) : (
              <DragUpload
                multiple={false}
                label="Qualification Documents"
                name="qualification"
                onChange={(fileList) =>
                  setQualificationFile(fileList && fileList[0]?.originFileObj)
                }
              />
            )}
          </Form.Item>
          <Form.Item
            name="DraDocuments"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
          >
            {draFile !== null ? (
              <DragUpload
                label="DRA Documents"
                name="dra"
                setFile={setDraFile}
                readOnly={true}
                file={draFile}
              />
            ) : (
              <DragUpload
                label="DRA Documents"
                name="dra"
                multiple={false}
                onChange={(fileList) =>
                  setDraFile(fileList && fileList[0]?.originFileObj)
                }
              />
            )}
          </Form.Item>
        </Flex>
      </div>
    ),
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      // width={window.innerWidth < 768 ? "calc(100vw - 40px)" : 1269}
      className="addUserModal"
    >
      <Tabs
        options={tabOptions}
        active={activeTab}
        onChange={(val) => {
          setActiveTab(val);
          form.resetFields();
        }}
        className="userTabs"
        showSelector={true}
        selectorBreakpoint={500}
      />

      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        className="userForm"
      >
        <h3 className="all-headlines">Add {activeTab}</h3>
        <div className="form-group">
          <Flex className="form-field">
            <Form.Item
              name="loginEmail"
              rules={[{ required: true, message: "Please enter login email" }]}
            >
              <InputField label="Login Email" placeholder="Enter your email" />
            </Form.Item>
            <Form.Item
              name="registeredEmail"
              rules={[
                { required: true, message: "Please enter registered email" },
              ]}
            >
              <InputField
                label="Registered Email"
                placeholder="Enter Registered Email"
              />
            </Form.Item>
          </Flex>
          <Flex className="form-field">
           {
            activeTab === 'TeleCaller' ? (
              <>
               <Form.Item name="first_name" rules={[{ required: true }]}>
              <InputField label="First Name" placeholder={`Enter first name`} />
            </Form.Item>
             <Form.Item name="last_name" rules={[{ required: true }]}>
              <InputField label="Last Name" placeholder={`Enter last name`} />
            </Form.Item>
              </>
            ) : (
               <Form.Item name="name" rules={[{ required: true }]}>
              <InputField label="Name" placeholder={`Type ${activeTab} Name`} />
            </Form.Item>
            )
           }
            <Form.Item
              name="joiningDate"
              label="Date of Joining"
              required={false}
              rules={[
                { required: true, message: "Please select a joining date" },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select join date"
                className="form-date-picker"
                suffixIcon={<Calender />}
              />
            </Form.Item>
          </Flex>
          <Flex className="form-field">
            <Form.Item
              label="Mobile Number"
              className="formItem mobileNumWrapper"
            >
              <Form.Item
                name="countryCode"
                noStyle
                rules={[
                  { required: false, message: "Please enter country code" },
                ]}
              >
                <Input
                  style={{ width: 100, marginRight: 8 }}
                  placeholder="+91"
                  value={91}
                 defaultValue={91}
                />
              </Form.Item>
              <Form.Item
                name="mobile"
                noStyle
                rules={[
                  { required: true, message: "Please enter mobile number" },
                ]}
              >
                <InputField placeholder="9999999999" maxLength={10} />
              </Form.Item>
            </Form.Item>
            <Form.Item name="address" rules={[{ required: true }]}>
              <InputField label="Address" placeholder="Write..." />
            </Form.Item>
          </Flex>
        </div>
        {roleSpecificFields[activeTab]}

        <div className="down-button">
          <NormalButton
            type="primary"
            htmlType="submit"
            className="submitBtn"
            loading={loading}
            style={{
              background: "linear-gradient(90deg, #d85b2b, #e3752f)",
              border: "none",
            }}
          >
            Add {activeTab}
          </NormalButton>
        </div>
      </Form>
    </Modal>
  );
};

export default AddUserModal;
